"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormNumberInput = void 0;
var react_1 = __importStar(require("react"));
var Controllers_1 = require("../Controllers");
var design_system_inputs_1 = require("@contrast-security-inc/design-system-inputs");
/**
 * Renders a NumberInput and connects it to the parent Form
 *
 * @typeParam TFormSchema - typescript interface of your form
 * @typeParam TFormField - a string path that matches one of the properties of your form. It should match the name property of the FormNumberInput.
 * @example
 * ```
 * <FormNumberInput<{foo: string; bar: number}, "foo"> name="foo" ...NumberInputProps />
 * ```
 */
exports.FormNumberInput = (0, react_1.forwardRef)(function (_a, ref) {
    var name = _a.name, onChange = _a.onChange, onBlur = _a.onBlur, inputProps = __rest(_a, ["name", "onChange", "onBlur"]);
    var controller = (0, Controllers_1.useFormInputController)({ name: name, onChange: onChange, onBlur: onBlur });
    return react_1.default.createElement(design_system_inputs_1.NumberInput, __assign({}, inputProps, controller, { containerRef: ref }));
});
exports.FormNumberInput.displayName = 'FormNumberInput';
